import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import VerifyIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';

import Validator, { useValidate, checkValidity } from '../validator';
import { useEffect } from 'react';


const MD5SourceURL = (props) => {
    // const [url, setURL] = useState(props.val);
    const urlForm = useValidate({});

    useEffect(() => {
        return () => {
            props.handleUnmount(Object.keys(urlForm.get())[0]);
        }
    }, []);

    const verifySource = () => {
        console.log(props.val, props.index);
        props.handleVerify(props.val, props.index);
    };

    const updateSource = (e, validID, valid) => {
        urlForm.set({...urlForm.get(), [validID]: valid});
        props.handleValidation(validID, valid);

        // setURL(e.target.value);
        props.handleUpdate(e.target.value, props.index);
    };

    const deleteSource = () => {
        props.handleDelete(props.index);
    }

    return (
        <Grid item xs={12}>
            <Box my={2}>
                <Validator
                    disabled={props.disabled}
                    errorText="File hash URL is invalid"
                    fullWidth
                    label={props.index+1}
                    value={props.val}
                    onChange={updateSource}
                    endAdornment={!props.disabled &&
                        <InputAdornment position="end">
                            <IconButton
                                variant="contained"
                                color="primary"
                                aria-label="verify source"
                                onClick={verifySource}
                                disabled={!checkValidity(urlForm.get())}
                                size="large">
                                <VerifyIcon />
                            </IconButton>
                            {!props.disabled && <IconButton
                                variant="contained"
                                color="secondary"
                                aria-label="delete source"
                                onClick={deleteSource}
                                size="large">
                                <DeleteIcon />
                            </IconButton>}
                        </InputAdornment>
                    }
                />
            </Box>
        </Grid>
    );
};

export default MD5SourceURL;
